<template>
  <v-menu bottom left
          :disabled="disabled"
          :close-on-content-click="false"
          v-model="displayed">

    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn v-if="showIcon"
              :disabled="disabled"
              :color="btnColor"
              :dark="btnColor && btnColor === 'accent'"
              :text="btnColor && btnColor !== 'accent'"
              icon>
          <v-icon>{{time ? 'access_time' : 'today'}}</v-icon>
        </v-btn>

        <span v-if="showLabel"
              v-bind:style="{ 'color': color }"
              class="ret-picker-label">
          <span v-if="pickerDate && pickerTime">
            {{ fullTime | dateTime }}
          </span>
          <span v-else-if="pickerDate && !time">
            {{ pickerDate | dateOnly }}
          </span>
          <span v-else>---</span>
        </span>
      </div>
    </template>

    <v-date-picker v-if="!time || !pickerDate"
                   v-model="pickerDate"
                   :first-day-of-week="1"/>
    <!--Showing both date picker and time picker in narrow window is broken.-->
    <!--Workaround is to hide date picker when date is already selected.-->
    <!--This however does not permit to edit already existing date-time value.-->

    <v-time-picker v-if="time && pickerDate"
                   v-model="pickerTime"
                   format="24hr"/>

  </v-menu>
</template>

<style scoped>
  .picker--date .date-picker-title__date {
    height: 48px;
  }

  .picker--date .picker__body {
    height: 290px !important;
  }

  .ret-picker-label {
    padding-right: 12px;
  }
</style>

<script>
import displayHelpers from '../../helpers/display-helpers.es6'
import moment from 'moment'

export default {
  name: 'ret-date-picker',
  mixins: [displayHelpers],
  props: {
    value: {}, // in any format supported by Moment
    disabled: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    time: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.87)'
    },
    btnColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      displayed: false,
      pickerDate: this.calculatePickerDate(),
      pickerTime: this.calculatePickerTime()
    }
  },
  computed: {
    fullTime () {
      const { pickerDate, pickerTime } = this
      return pickerDate && pickerTime && `${pickerDate}T${pickerTime}`
    }
  },
  watch: {
    value () {
      this.pickerDate = this.calculatePickerDate()
      this.pickerTime = this.calculatePickerTime()
    },
    pickerDate () {
      const { time, pickerDate } = this
      if (!time) {
        this.$emit('input', pickerDate ? moment(pickerDate).format() : pickerDate)
        this.displayed = false
      }
    },
    pickerTime () {
      const { fullTime } = this
      this.$emit('input', fullTime ? moment(fullTime).format() : fullTime)
      this.displayed = false
    }
  },
  methods: {
    calculatePickerDate () {
      const { value } = this
      return value && moment(value).format('YYYY-MM-DD')
    },
    calculatePickerTime () {
      const { time, value } = this
      return time && value && moment(value).format('HH:mm')
    }
  }
}
</script>
